import request from './libs/request'
import sign from './libs/sign'
import base from './libs/base'

const login = (params) => {
	return request.post(`${ base.BASE_API }/login`, sign.main(params) )
}
const getMsg = (params) => {
	return request.post(`${ base.BASE_SMS_API }/public/sms/send`, sign.other(params, 'SMS') )
}
const register = (params) => {
	return request.post(`${ base.BASE_API }/register`, sign.main(params) )
}
const authorization = (params) => {
	return request.get(`${ base.BASE_API }/auth/url`, { params: sign.main(params) })
}
const authCreate = (params) => {
	return request.post(`${ base.BASE_API }/auth/create`, sign.main(params) )
}
const appList = (params) => {
	return request.get(`${ base.BASE_API }/auth/app_list`, { params: sign.main(params) })
}
export {
	login,
	register,
	getMsg,
	authCreate,
	authorization,
	appList,
}


// WEBPACK FOOTER //
// ./src/api/login.js